import React from "react";
import ContactForm from "@/src/forms/contact-form";
import { useTranslation } from "next-export-i18n";
import Image from "next/image";

import LineArrow from "@/src/svg/line-arrow-5";
import testimonial_shape_2 from "@assets/img/testimonial/home-3/shape-2.png";

const ContactArea = () => {
    const { t } = useTranslation();

    return (
        <>
            <section className="tp-contact-area pt-60 pb-90">
                <div className="container">
                    <div className="mb-50 contact-header">
                        <h3
                            className="platform__title contact-title"
                            style={{ margin: 0 }}
                        >
                            {t("contact.title.secondary")}{" "}
                            <span className="platform__title-primary">
                                {t("contact.title.primary")}
                            </span>
                            <span className="title-right-shape">
                                <LineArrow />
                            </span>
                        </h3>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="tp-contact-wrapper pt-60">
                                <div className="tp-contact-content">
                                    <p>{t("contact.hint")}</p>
                                    <div className="tp-contact-content-mail d-flex align-items-center">
                                        <div className="tp-contact-content-mail-icon">
                                            <span>
                                                <i className="fa-light fa-envelope fa-3x" />
                                            </span>
                                        </div>
                                        <h3 className="tp-contact-item-title">
                                            <a href="mailto:info@nuviad.com">
                                                info@nuviad.com
                                            </a>
                                        </h3>
                                    </div>
                                    <div className="tp-contact-content-address d-flex align-items-center">
                                        <div className="tp-contact-content-address-icon">
                                            <span>
                                                <i className="fa-light fa-location-dot fa-3x" />
                                            </span>
                                        </div>
                                        <h3 className="tp-contact-item-title">
                                            <a
                                                target="_blank"
                                                href="https://www.google.com/maps/search/Ha-Tamar+St+3,+Yokne'am+Illit,+2062002,+Israel/@32.6608571,35.1035431,17z/data=!3m1!4b1"
                                            >
                                                Ha-Tamar St 3 Yokne'am Illit,
                                                Israel.
                                            </a>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="tp-contact-form">
                                <ContactForm />
                                <p className="ajax-response" />
                                <div className="tp-testimonial-3-shape">
                                    <Image
                                        src={testimonial_shape_2}
                                        alt="theme-pure"
                                        className="shape-2"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ContactArea;
